<template>
      <ExhibitorList />
</template>

<script>
import ExhibitorList from "./ExhibitorList/ExhibitorListing";
export default {
  name: "exhibitorlist",
  components: {
    ExhibitorList
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
};
</script>





